const getTotalMinutes = (sec) => {
  return Math.floor(sec / 60);
};

const getPadString = (num) => {
  return String(num).padStart(2, '0');
};

const SettingController = ({ label, displayTime, onClick }) => {
  return (
    <div className='flex justify-between items-center w-full gap-3'>
      <div className='bg-tertiary px-2 py-1 rounded-xl border border-[#d8d8d8] flex justify-between items-center w-2/3 gap-2 text-lg text-white'>
        <div>{label}</div>
        <div>{displayTime}</div>
      </div>
      <div className='border border-[#d8d8d8] rounded-xl flex justify-between items-center divide-x-2 p-1 w-1/3 text-2xl text-white'>
        <button
          className=' flex-1'
          name='-'
          onClick={onClick}
        >
          -
        </button>
        <button
          className=' flex-1'
          name='+'
          onClick={onClick}
        >
          +
        </button>
      </div>
    </div>
  );
};

const Setup = ({ setSetting, setting, getTotalWorkoutTime }) => {
  const setExerciseAndSet = (key) => (e) => {
    const value = setting[key];
    if (e.target.name === '-' && value - 1 >= 0) {
      setSetting({ ...setting, [key]: value - 1 });
    }
    if (e.target.name === '+') {
      setSetting({ ...setting, [key]: value + 1 });
    }
  };

  const setTimes = (key) => (e) => {
    let times = setting[key]
      .split(':')
      .reduce((acc, curr) => Number(acc) * 60 + Number(curr));

    if (e.target.name === '-' && times - 5 >= 0) {
      let minutes = getPadString(getTotalMinutes(times - 5));
      let seconds = getPadString((times - 5) % 60);

      setSetting({
        ...setting,
        [key]: `${minutes}:${seconds}`,
      });
    }
    if (e.target.name === '+') {
      let minutes = getPadString(getTotalMinutes(times + 5));
      let seconds = getPadString((times + 5) % 60);

      setSetting({
        ...setting,
        [key]: `${minutes}:${seconds}`,
      });
    }
  };

  return (
    <div className='mt-5 bg-secondary p-3 rounded-xl border border-tertiary flex flex-col w-full gap-3'>
      <SettingController
        label='Ready time'
        displayTime={setting.prepTime}
        onClick={setTimes('prepTime')}
      />
      <SettingController
        label='Exercise time'
        displayTime={setting.exerciseTime}
        onClick={setTimes('exerciseTime')}
      />
      <SettingController
        label='Rest in exercises'
        displayTime={setting.exerciseRestTime}
        onClick={setTimes('exerciseRestTime')}
      />
      <SettingController
        label='Exercise'
        displayTime={setting.totalRound}
        onClick={setExerciseAndSet('totalRound')}
      />
      <SettingController
        label='Rest in sets'
        displayTime={setting.tabataRestTime}
        onClick={setTimes('tabataRestTime')}
      />
      <SettingController
        label='Set'
        displayTime={setting.totalTabata}
        onClick={setExerciseAndSet('totalTabata')}
      />
      <div className='text-2xl font-bold flex justify-center items-center gap-3'>
        <div className='text-white'>Total workout</div>
        <div className='text-orange-300'>{getTotalWorkoutTime()}</div>
      </div>
    </div>
  );
};

export default Setup;
